/**
 *
 * Divider
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';

function DynamicDivider({ top, right, bottom, left, children, width }) {
  const styles = {
    root: {
      marginTop: top,
      marginRight: right,
      marginBottom: bottom,
      marginLeft: left,
      backgroundColor: '#E9ECED',
      height: 1,
    },
  };

  if (width) {
    styles.root.width = width;
  }
  /* eslint-disable */
  const div = props => (
    <Divider className={props.classes.root}>{children}</Divider>
  );
  const Styled = withStyles(styles)(div);
  return <Styled>{children}</Styled>;
}

DynamicDivider.propTypes = {
  children: PropTypes.node,
  top: PropTypes.number,
  right: PropTypes.number,
  bottom: PropTypes.number,
  left: PropTypes.number,
  width: PropTypes.string,
};

export default DynamicDivider;
